import prop from 'ramda/src/prop'
import createRecordClickActionStoreKey from 'root/src/client/logic/api/util/createRecordClickActionStoreKey'
import { apiStoreLenses } from 'root/src/client/logic/api/lenses'

const { viewRecordClickActionProcessing } = apiStoreLenses

export default (state, { recordClickActionId, recordId }) => {
	const recordClickActionKey = createRecordClickActionStoreKey(recordClickActionId, recordId)
	return prop(recordClickActionKey, viewRecordClickActionProcessing(state))
}
